module.exports = __webpack_public_path__ + "img/vitosha-park-hotel.4d18be73.jpg";